import { GetApplicationResponse } from '@iwoca/lapi-client/edge';
import Cookies from 'js-cookie';

import { getLatestStepDE } from '../../helpers/getLatestStep/getLatestStepDE';
import { TGetStateResponseDE } from '../../lapiOverrideTypesDE';

const MOBILE_BREAKPOINT_PX = 768;

const PRE_ACCOUNT_STEPS_DE = ['', 'neu'];

export const PREVIEW_COOKIE_NAME = 'iw-de-mobile-signup-preview';

export const isMobileSignupPreviewEnabled = () =>
  Cookies.get(PREVIEW_COOKIE_NAME) === 'true';

export const getIsMobileViewport = () =>
  window.innerWidth < MOBILE_BREAKPOINT_PX;

export const isPreAccountStepDE = (currentStep: string) =>
  PRE_ACCOUNT_STEPS_DE.includes(currentStep);

export const isApplicationCompleteDE = (
  state: TGetStateResponseDE['data'],
  application: GetApplicationResponse['data'],
) => getLatestStepDE(state, application) === 'angebote';
